
const addToCartText = () => {
    let addToCartButtons = document.querySelectorAll('.add_to_cart_button');

    addToCartButtons.forEach(addToCartButton => {
        console.log(addToCartButton.textContent)
        addToCartButton.textContent = "Добавить в корзину";
        addToCartButton.addEventListener('click', () => {
            addToCartButton.style.opacity = 0;
            addToCartButton.style.height = '0px';
        })
    });

}

export default addToCartText;